import http from "@/utils/request";

const order = {
  // 获取订单列表
  list: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderOrderService.queryOrder4Page",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 批量取消订单
  cancelOrders: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderOrderService.cancelOrders",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 批量导入运单号信息
  batchImportMailNo: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderStockoutService.batchImportMailNo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 批量修改订单状态
  batchChangeOrderState: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderStockoutService.batchMarkOrderState",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 预览运单信息
  perviewMailNoImport: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderStockoutService.previewBatchImport",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 批量导出订单号
  exportOrderList: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderOrderService.submitDownloadOrderTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  createTicket: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderOrderService.createTicket",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 订单详情
  orderDetail: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderOrderService.queryOrderDetail",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 售后单下载
  downloadRefundOrder: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderOrderService.submitDownloadRefundOrderListPriceTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 售后单列表
  refundOrderList: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderOrderService.queryRefundOrder4Page",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 售后单详情页
  refundOrderDetail: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderOrderService.queryRefundOrderDetail",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 获取异常订单列表
  ticketList: (data) =>
    http.sendRequest({
      METHOD_NAME: "vender.queryTicket4Page",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 开主平台订单导入
  openPlatformOrderImport: (data) =>
    http.sendRequest({
      METHOD_NAME:
        "openPlatformOrderImport.previewBatchImportOpenPlatformOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  importOrderData: (data) =>
    http.sendRequest({
      METHOD_NAME: "openPlatformOrderImport.importOrderData",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  orderErrorPageQuery: (data) =>
    http.sendRequest({
      METHOD_NAME: "orderError.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  orderErrorLoad: (data) =>
    http.sendRequest({
      METHOD_NAME: "orderError.load",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  orderErrorDelete: (data) =>
    http.sendRequest({
      METHOD_NAME: "orderError.delete",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  orderErrorExport: (data) =>
    http.sendRequest({
      METHOD_NAME: "orderError.export",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  orderErrorRetry: (data) =>
    http.sendRequest({
      METHOD_NAME: "orderError.retry",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default order;
